<template>
    <div>
        <top-bar
            :height="'48vh'"
            title="用户持有优惠券"
            :isShowRefresh="true"
            :loading="loading"
            @refresh="refresh"
            @search="search"
        />
        <v-container fluid class="mt-n6">
			<div class="count-money">
				<div class="count-box">
					<div class="count-title">
						数量
					</div>
					<div class="count-num">
						{{countMoney.count ? countMoney.count : 0}}
					</div>
				</div>
				<div class="count-box" style="margin-left: 1rem;">
					<div class="count-title">
						金额总计(￥)
					</div>
					<div class="count-num">
						{{countMoney.total_money ? countMoney.total_money / 100 : 0}}
					</div>
				</div>
			</div>
            <div class="search">
                <div class="time">
                    <el-date-picker
                        v-model="form.time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="timestamp"
                        style="width:98%"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </div>
                <div class="mobile">
                    <el-input
                        type="text"
                        v-model="form.mobile"
                        clearable
                        style="width: 95%"
                        placeholder="手机号码"
                    ></el-input>
                </div>
                <div class="mobile">
                    <el-input
                        type="text"
                        v-model="form.name"
                        clearable
                        style="width: 95%"
                        placeholder="优惠券名称"
                    ></el-input>
                </div>
				<div class="mobile" v-if="role === 0">
					<select-platform
						@choose="choosePlatformId"
					    :selectPlatform="form.platform_id"
					    :width="'98%'"
					/>
				</div>
                <div class="btn-search">
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="searchBtn()"
                        size="medium"
                    ></el-button>
                </div>
            </div>
            <v-data-table
                :headers="headers"
                :items="userCouponList"
                :loading="loading"
                loading-text="数据加载中..."
                no-data-text="未查询到数据"
                :server-items-length="totalCount"
                class="elevation-1 mt-5"
                disable-sort
                :dark="theme.tableDark"
                :options.sync="options"
                :footer-props="footerProps"
            >
                <template v-slot:item.name="{ item }">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                        <div class="textOver" style="width: 5rem;">
                            {{ item.name }}
                        </div>
                    </el-tooltip>
                </template>
                <template v-slot:item.info="{ item }">
                    <el-tooltip class="item" effect="dark" :content="item.info" placement="top">
                        <div class="textOver">{{ item.info }}</div>
                    </el-tooltip>
                </template>
                <template v-slot:item.used_date="{ item }">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.used_date"
                        placement="top"
                    >
                        <div class="textOver" style="width:8.3rem">
                            {{ item.used_date }}
                        </div>
                    </el-tooltip>
                </template>
                <template v-slot:item.expire_date="{ item }">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.expire_date"
                        placement="top"
                    >
                        <div class="textOver" style="width:8.3rem">{{ item.expire_date }}</div>
                    </el-tooltip>
                </template>
                <template v-slot:item.price="{ item }">
                    {{ item.price / 100 }}
                </template>
                <template v-slot:item.money="{ item }">
                    {{ item.money / 100 }}
                </template>
                <template v-slot:item.type="{ item }">
                    <div class="textOver" style="width: 4rem;">
                        {{ typeT(item.type) }}
                    </div>
                </template>
                <template v-slot:item.stations="{ item }">
                    <div v-for="(id, index) in item.stations" :key="index">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="showStationName(id)"
                            placement="top"
                        >
                            <div
                                class="textOver"
                                style="width:5.5rem;color:#40a9ff;padding: 0.3rem 0 0 0"
                            >
                                {{ showStationName(id) }}
                            </div>
                        </el-tooltip>
                    </div>
                </template>
                <template v-slot:item.state="{ item }">
                    <div
                        class="textOver"
                        :style="{
                            color: judgeTime(item.used_date, item.expire_date, 'color'),
                            width: '4rem',
                        }"
                    >
                        {{ judgeTime(item.used_date, item.expire_date, "text") }}
                    </div>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store";
import Public from "@/public";
import TopBar from "@/components/TopBar";
import util from "@/util/index";
import SelectPlatform from "@/components/SelectPlatform";
export default {
    name: "UserCoupons",
    data() {
        return {
            headers: [
                { text: "名称", value: "name" },
                { text: "信息", value: "info" },
                { text: "价格(元)", value: "price" },
                { text: "金额(元)", value: "money" },
                { text: "可使用次数", value: "type" },
                { text: "用户id", value: "user_id" },
                { text: "站点", value: "stations" },
                { text: "使用时间", value: "used_date" },
                { text: "到期时间", value: "expire_date" },
                { text: "状态", value: "state" },
            ],
            userCouponList: [],
            loading: false, //刷新
            typeText: [
                {
                    id: 0,
                    value: "无限制",
                },
                {
                    id: 1,
                    value: "一次性",
                },
            ],
            validText: [
                {
                    id: 1,
                    value: "是",
                },
                {
                    id: 0,
                    value: "否",
                },
            ],
            totalCount: 100000,
            options: {}, //外部控制分页
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            form: {
                time: null,
                mobile: null,
                name: null,
				platform_id: null,
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
			countMoney: {}
		};
    },
    computed: {
        ...mapState(["theme", "userCouponInfos", "siteInfo","role","platform_id"]),
    },
    mounted() {
		if(this.role !== 0) {
			this.form.platform_id = this.platform_id
		}
	},
    components: {
        TopBar,
		SelectPlatform
    },
    watch: {
        options: {
            handler(val) {
                this.searchBtn()
            },
            // deep: true,
        },
    },
    methods: {
        /*刷新*/
        refresh() {
            
            // let time = this.returnTime(this.form.time);
            // const { page, itemsPerPage } = this.options;
            this.searchBtn()
			this.couponQuerySum()
        },
        /*选择平台*/
        choosePlatformId(platformId) {
            this.form.platform_id = platformId;
            this.searchBtn();
        },
		/*搜索*/
        async search(reg) {
            let params = {
                postData: {},
                callback: () => {
                    this.loading = false;
                },
                callbackOk: () => {
                    util.ShowTip("搜索成功", 1);
                },
                callbackError: () => {
                    util.ShowTip("搜索失败", 2);
                },
            };
            await store.dispatch("getUserCoupon", params);
            let datas = [];
            for (let i = 0; i < this.userCouponInfos.length; i++) {
                if (
                    reg.test(this.userCouponInfos[i].name) ||
                    reg.test(this.userCouponInfos[i].info) ||
                    reg.test(this.userCouponInfos[i].money) ||
                    reg.test(this.userCouponInfos[i].price) ||
                    reg.test(this.userCouponInfos[i].id) ||
                    reg.test(this.userCouponInfos[i].user_id)
                ) {
                    datas.push(this.userCouponInfos[i]);
                }
            }
            console.log(datas);
            this.userCouponList = datas;
        },
        /*搜索按钮*/
        searchBtn() {
			this.loading = true;
            let time = this.returnTime(this.form.time);
            const { page, itemsPerPage } = this.options;
            let params = {
                postData: {},
                isSearch: true,
                callback: () => {
                    this.loading = false;
                },
                callbackOk: () => {
                    util.ShowTip("搜索成功", 1);
                },
                callbackError: () => {
                    util.ShowTip("搜索失败", 2);
                },
            };
            if (!this.form.name) {
                this.form.name = null;
            }
            if (!this.form.mobile) {
                this.form.mobile = null;
            }
			if(this.form.mobile && !this.form.platform_id) {
				util.ShowTip("请选择平台", 3);
				this.loading = false;
				return;
			}
            if (time) {
                params.postData = {
                    from: (page - 1) * itemsPerPage,
                    limit: itemsPerPage,
                    end_time: time.end_time,
                    start_time: time.start_time,
                    name: Public.removeSpace(this.form.name),
                    mobile: Public.removeSpace(this.form.mobile),
					platform_id: this.form.platform_id
                };
            } else {
                params.postData = {
                    from: (page - 1) * itemsPerPage,
                    limit: itemsPerPage,
                    name: Public.removeSpace(this.form.name),
                    mobile: Public.removeSpace(this.form.mobile),
					platform_id: this.form.platform_id
                };
            }
            this.getData(params);
        },
        /*获取数据*/
        async couponQuerySum() {
            let params = {
				postData: {},
                callbackOk: (data)=> {
					console.log(data)
					this.countMoney = data.data
				}
            };
            await store.dispatch("couponQuerySum", params);
        },
		/*获取数据*/
        async getData(params) {
            await store.dispatch("getUserCoupon", params);
            let postData = {
                from: 0,
                limit: 10000,
            };
            await store.dispatch("getSite", postData);
            this.userCouponList = JSON.parse(JSON.stringify(this.userCouponInfos));
        },
        typeT(type) {
            let text = "";
            for (let i = 0; i < this.typeText.length; i++) {
                if (type == this.typeText[i].id) {
                    text = this.typeText[i].value;
                }
            }
            return text;
        },
        validT(valid) {
            let text = "";
            for (let i = 0; i < this.validText.length; i++) {
                if (valid == this.validText[i].id) {
                    text = this.validText[i].value;
                }
            }
            return text;
        },
        /*显示站点名称*/
        showStationName(station_id) {
            let idArr = [];
            let text = null;
            for (let i = 0; i < this.siteInfo.length; i++) {
                if (station_id == this.siteInfo[i].id) {
                    text = this.siteInfo[i].name;
                }
                idArr.push(this.siteInfo[i].id);
            }
            if (!idArr.includes(station_id)) {
                text = station_id;
            }
            return text;
        },
        /*返回开始时间和结束时间*/
        returnTime(time) {
            if (!time) {
                return;
            }
            let now = new Date();
            let endTime = null;
            let startTime = null;
            if (time && time[1] != time[0]) {
                startTime = Math.floor(time ? time[0] / 1000 : 0);
                endTime = Math.floor((time ? time[1] : now.getTime()) / 1000) + 86400;
            } else if (time && time[1] == time[0]) {
                startTime = Math.floor(time ? time[0] / 1000 : 0);
                endTime = Math.floor(time[0] / 1000) + 86400;
            }
            return {
                end_time: endTime,
                start_time: startTime,
            };
        },
        /*判断优惠券状态*/
        judgeTime(used_date, expire_date, type) {
            let expireTime = Date.parse(new Date(expire_date));
            let nowTime = Date.parse(new Date());
            if (used_date) {
                if (type == "color") {
                    return "#bfbfbf";
                } else {
                    return "已使用";
                }
            } else if (nowTime > expireTime) {
                if (type == "color") {
                    return "#ff7875";
                } else {
                    return "已过期";
                }
            } else {
                if (type == "color") {
                    return "#69c0ff";
                } else {
                    return "未使用";
                }
            }
        },
    },
};
</script>
<style scoped>
.count-money {
	width: 100%;
	height: 6rem;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
}
.count-box {
	width: 20%;
	height: 6rem;
	background-color: #fff;
	border-radius: 1.2rem;
	box-shadow:0 1rpx 4rpx rgba(87, 96, 111, 0.2), 0 0 15rpx rgba(87, 96, 111, 0.1) inset;
	position: relative;
}
.count-title {
	position: absolute;
	top: 0.5rem;
	left: 2rem;
	font-size: 0.9rem;
	font-weight: 700;
}
.count-num {
	position: absolute;
	top: 2rem;
	width: 100%;
	height: 4rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.4rem;
	color: #2ed573;
}
.textOver {
    width: 10rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.search {
    width: 100%;
    min-height: 3.5rem;
    display: flex;
    flex-direction: row;
	flex-wrap: wrap;
    border-radius: 0.8rem;
    background-color: #eff1f7;
}
.time {
    width: 25rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.mobile {
    width: 15rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-search {
    width: 4rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
